import { projectNameMap } from '@constants'
import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { ArrowRightSmall } from '@pets-ui/icons'
import { Image } from '@pets-ui/Image/Image'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { brandImageMap, type BrandInfo } from '../../constants'

const styles = stylex.create({
  logoShadowWrapper: {
    filter: 'drop-shadow(6px 0px 8px rgba(0, 0, 0, 0.08))',
  },
  logoClip: {
    clipPath: 'polygon(0 0, calc(100% - 24px) 0, 100% 100%, 0 100%)',
  },
})

interface BrandTitleBarProps {
  brand: BrandInfo
  onNavigateToBrand?: () => void
}

export const BrandTitleBar = (props: BrandTitleBarProps) => {
  const { brand, onNavigateToBrand } = props
  const avatarSrc = brandImageMap[brand.projectCode]?.avatar
  const brandName = projectNameMap[brand.projectCode]

  return (
    <Box height={56} position="relative">
      {/* 背景區塊 */}
      <Box position="absolute" top={12} bottom={0} left={0} right={0} backgroundColor={colors.white} borderTopRightRadius={8} />
      {/* 左側品牌 logo */}
      <Box rootStyle={styles.logoShadowWrapper} position="absolute" top={0} left={0} height="100%" width={156}>
        <Box
          rootStyle={styles.logoClip}
          height="100%"
          backgroundColor={colors.primary100}
        >
          <HStack gap={3} alignItems="center" height="100%" px={3}>
            {avatarSrc && (
              <Image src={avatarSrc} alt={brandName} width={28} height={28} />
            )}
            <Text variant="h5" color={colors.grey800}>{brandName}</Text>
          </HStack>
        </Box>
      </Box>
      {/* 右側「前往品牌館」連結 */}
      {onNavigateToBrand && (
        <HStack position="absolute" top={12} bottom={0} right={12} gap={0} alignItems="center" cursor="pointer" onClick={onNavigateToBrand}>
          <Text color={colors.blue600}>前往品牌館</Text>
          <ArrowRightSmall color={colors.blue600} fontSize={14} />
        </HStack>
      )}
    </Box>
  )
}
